import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../libs/axios';
import Breadcrumb from '../../utils/breadcrumbs';

interface Official { id: number; role: string; user_id: number; match_id: number | null; tournament_id: number | null; user: { id: number; name: string | null; phone_number: string | null }; }
const ROLES = ['umpire', 'scorer', 'commentator', 'live_streamer', 'organizer'];

const Officials: React.FC = () => {
  const [scope, setScope] = useState<{ type: 'match' | 'tournament'; id: string }>({ type: 'match', id: '' });
  const [officials, setOfficials] = useState<Official[]>([]);
  const [form, setForm] = useState({ role: 'scorer', user_id: '' });

  const load = async () => {
    if (!scope.id) { toast.error('Enter an ID'); return; }
    try { const res: any = await api.get(`/officials?${scope.type}_id=${scope.id}`); setOfficials(res.data || []); }
    catch (e) { toast.error('Failed to load'); }
  };
  const assign = async () => {
    if (!scope.id || !form.user_id) { toast.error('Scope ID and user ID required'); return; }
    try {
      await api.post('/officials', { role: form.role, user_id: Number(form.user_id), [`${scope.type}_id`]: Number(scope.id) });
      toast.success('Assigned'); setForm({ role: 'scorer', user_id: '' }); load();
    } catch (e) { toast.error('Assign failed'); }
  };
  const remove = async (id: number) => {
    try { await api.delete(`/officials/${id}`); toast.success('Removed'); load(); }
    catch (e) { toast.error('Remove failed'); }
  };

  return (
    <div className="p-4 sm:p-6">
      <Breadcrumb />
      <div className="mt-4 mb-6">
        <h1 className="text-xl font-semibold text-gray-900">Officials & Scorers</h1>
        <p className="text-sm text-gray-500">Assign umpire / scorer / organizer to a match or tournament.</p>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-5 mb-6 max-w-3xl">
        <div className="flex flex-wrap gap-2 items-end">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Scope</label>
            <select value={scope.type} onChange={(e) => setScope((p) => ({ ...p, type: e.target.value as 'match' | 'tournament' }))} className="rounded-lg border border-gray-300 px-3 py-2 text-sm">
              <option value="match">Match</option><option value="tournament">Tournament</option>
            </select>
          </div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">ID</label>
            <input value={scope.id} onChange={(e) => setScope((p) => ({ ...p, id: e.target.value }))} className="rounded-lg border border-gray-300 px-3 py-2 text-sm w-28" /></div>
          <button onClick={load} className="bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium px-4 py-2 rounded-lg">Load</button>
        </div>
        <div className="border-t border-gray-100 mt-4 pt-4 flex flex-wrap gap-2 items-end">
          <div><label className="block text-xs font-medium text-gray-600 mb-1">Role</label>
            <select value={form.role} onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))} className="rounded-lg border border-gray-300 px-3 py-2 text-sm capitalize">
              {ROLES.map((r) => <option key={r} value={r}>{r.replace('_', ' ')}</option>)}
            </select></div>
          <div><label className="block text-xs font-medium text-gray-600 mb-1">User ID</label>
            <input value={form.user_id} onChange={(e) => setForm((p) => ({ ...p, user_id: e.target.value }))} className="rounded-lg border border-gray-300 px-3 py-2 text-sm w-28" /></div>
          <button onClick={assign} className="bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg">Assign</button>
        </div>
      </div>

      {officials.length > 0 && (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600"><tr>
              <th className="text-left font-medium px-4 py-3">Role</th>
              <th className="text-left font-medium px-4 py-3">User</th>
              <th className="text-right font-medium px-4 py-3">Action</th>
            </tr></thead>
            <tbody>
              {officials.map((o) => (
                <tr key={o.id} className="border-t border-gray-100">
                  <td className="px-4 py-3 capitalize text-gray-900">{o.role.replace('_', ' ')}</td>
                  <td className="px-4 py-3 text-gray-600">{o.user.name || `#${o.user_id}`} <span className="text-xs text-gray-400">{o.user.phone_number || ''}</span></td>
                  <td className="px-4 py-3 text-right"><button onClick={() => remove(o.id)} className="text-xs text-red-600 hover:underline">Remove</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
export default Officials;
